module.exports = __webpack_public_path__ + "3d3a53586bd78d1069ae4b89a3b9aa98.svg";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.svg
// module id = 378
// module chunks = 1